import { useTranslation } from 'react-i18next';

import { vocalTypeKeys } from '../../resultCopy';

import type { DiagnosisRecord } from '../../record';

/** 조각 키 → 한 문장("맑고 안정적인 밸런스형"). 조각이 없으면 "이번엔 못 쟀어요". */
export const VocalTypeLine = ({ record }: { record: DiagnosisRecord }) => {
  const { t } = useTranslation();
  const parts = vocalTypeKeys(record);
  const label = parts
    ? t(`web.result.summary.type${parts.length}`, {
        p1: t(`web.result.summary.typeParts.${parts[0]}`),
        p2: parts[1] && t(`web.result.summary.typeParts.${parts[1]}`),
        p3: parts[2] && t(`web.result.summary.typeParts.${parts[2]}`),
      })
    : t('web.result.pending');
  return (
    <div className="mt-4 flex items-baseline justify-between gap-3 border-t border-border pt-3">
      <span className="text-sm text-muted-foreground">
        {t('web.result.summary.type')}
      </span>
      <span className="text-base font-semibold">{label}</span>
    </div>
  );
};
